import { buildCatNavProductsRequest } from "@faire/retailer-shared/categories/createRequests/buildCatNavProductsRequest";

import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useRequestReferrer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { useLoggedOutCategoryPageRequestPageSize } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageRequestPageSize";

export const useLoggedOutCategoryPageCatNavRequest = () => {
  const navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
  const filterKeys = useCategoryPageFilterKeys();
  const referrer = useRequestReferrer();
  const { oneIndexedPageNumber } = useCategoryPageQueryParams();
  const page_size = useLoggedOutCategoryPageRequestPageSize();

  return buildCatNavProductsRequest({
    navigationPath,
    filterKeys,
    pageNumber: oneIndexedPageNumber,
    pageSize: page_size,
    requestReferrer: referrer,
    shouldRequestRetrievalRankingDebugInfo: false,
  });
};
